import { cx } from "shared/utils";
import { UnitLockboxStatus } from "types/landlord/address";

const VENDOR_LOGOS: Record<
  string,
  { src: string; alt: string; className: string }
> = {
  codebox: {
    src: "/assets/codebox_logo_color.png",
    alt: "CodeBox",
    className: "h-3"
  },
  sentrilock: {
    src: "/assets/sentrilock_logo.png",
    alt: "SentriLock",
    className: "h-5"
  },
  igloohome: {
    src: "/assets/igloohome_logo.png",
    alt: "igloohome",
    className: "h-5"
  }
};

export const UnitLockboxPill = ({
  lockboxStatus
}: {
  lockboxStatus?: UnitLockboxStatus;
}) => {
  if (!lockboxStatus?.assigned) return null;

  const logo = lockboxStatus.vendor
    ? VENDOR_LOGOS[lockboxStatus.vendor]
    : undefined;

  return (
    <span className="flex items-center justify-center rounded-full border border-alpha-100 bg-content-1000-inverted py-1 pl-2 pr-2.5 shadow-sm h-6">
      {logo ? (
        <img
          src={logo.src}
          alt={logo.alt}
          className={cx("w-auto max-w-[84px] object-contain", logo.className)}
        />
      ) : (
        <span className="text-xs font-medium uppercase text-content-1000">
          Lockbox
        </span>
      )}
    </span>
  );
};
